export default "__VITE_ASSET__96fdb458__"